var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXenonstackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 839,
    height: 143,
    viewBox: "0 0 839 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.923 108.304H207.017L186.6 75.9959L166.182 108.304H154.387L180.702 67.8063L157.33 33.0938H169.126L186.6 59.8362L204.184 33.0938H215.98L192.498 67.9161L218.923 108.304Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.109 99.1267H275.705V108.293H230.279V33.0938H274.618V42.2604H240.109V66.7085H270.247V75.9849H240.109V99.1267Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336.1 33.0938H346.04V108.293H336.43L301.701 50.988V108.293H291.762V33.0938H301.592L336.1 90.1795V33.0938Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M361.658 70.8482C361.658 49.452 378.254 31.7773 399.659 31.7773C421.065 31.7773 437.88 49.463 437.88 70.8482C437.88 92.2334 421.175 109.601 399.659 109.601C378.144 109.601 361.658 92.1346 361.658 70.8482ZM427.941 70.8482C427.941 54.6995 415.706 40.944 399.659 40.944C383.613 40.944 371.598 54.6995 371.598 70.8482C371.598 86.9969 383.833 100.423 399.659 100.423C415.486 100.423 427.941 86.8871 427.941 70.8482Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M498.055 33.0938H507.995V108.293H498.385L463.656 50.988V108.293H453.717V33.0938H463.547L498.055 90.1795V33.0938Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M523.934 87.0149H533.763C534.093 93.6786 540.419 100.441 550.469 100.441C560.518 100.441 565.647 94.1067 565.647 87.454C565.647 80.1427 558.98 76.8712 552.654 75.2245L542.934 72.8203C526.987 69 524.483 59.6137 524.483 53.499C524.483 40.512 536.169 31.7734 549.271 31.7734C562.374 31.7734 573.072 40.1826 573.072 53.6088H563.242C563.242 46.0778 557.014 40.9511 548.942 40.9511C541.408 40.9511 534.422 45.968 534.422 53.3892C534.422 56.0129 535.301 61.2495 545.34 63.8622L555.169 66.486C567.943 69.8672 575.587 76.4211 575.587 87.1137C575.587 98.7944 566.086 109.597 550.469 109.597C534.851 109.597 524.043 98.6846 523.934 87.0039V87.0149Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M636.959 33.0938V42.2604H614.026V108.293H604.087V42.2604H581.154V33.0938H636.959Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M690.367 108.301L683.052 88.9798H650.729L643.414 108.301H633.035L661.646 33.1016H672.124L700.735 108.301H690.356H690.367ZM654.002 80.2413H679.768L666.885 46.0776L654.002 80.2413Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M705.008 70.8482C705.008 49.5618 721.933 31.7773 743.229 31.7773C754.805 31.7773 764.854 36.6845 771.51 44.5448L764.305 50.6596C759.286 44.7644 751.642 40.944 743.229 40.944C727.391 40.944 714.948 54.6995 714.948 70.8482C714.948 86.9969 727.391 100.423 743.229 100.423C751.642 100.423 759.286 96.6026 764.305 90.7074L771.51 96.8222C764.843 104.682 754.805 109.59 743.229 109.59C721.933 109.59 705.008 92.1236 705.008 70.8372V70.8482Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M838.674 108.304H825.461L795.324 76.1057V108.304H785.494V33.0938H795.324V65.951L820.552 33.0938H832.677L803.627 70.7484L838.685 108.293L838.674 108.304Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M0 106.145L66.0849 80.9727L131.544 106.145L66.0849 129.814L0 106.145Z",
    fill: "#50B448"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1555 112.282L66.0849 92.9936L118.013 111.031L131.544 106.145L66.0849 80.9727L0 106.145L17.1555 112.282Z",
    fill: "#2DAF4A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M0 106.148V119.761L66.0849 143.002L131.544 118.696V106.148L66.0849 129.817L0 106.148Z",
    fill: "#7DBF57"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M0 79.1531L66.0849 53.9805L131.544 79.1531L66.0849 102.822L0 79.1531Z",
    fill: "#FFC804"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1555 85.2898L66.0849 66.0124L118.013 84.0383L131.544 79.1531L66.0849 53.9805L0 79.1531L17.1555 85.2898Z",
    fill: "#FAB911"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M0 79.1523V92.7651L66.0849 116.006L131.544 91.7112V79.1523L66.0849 102.821L0 79.1523Z",
    fill: "#FFD151"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M0 52.1648L66.0849 26.9922L131.544 52.1648L66.0849 75.8335L0 52.1648Z",
    fill: "#4C97FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1555 58.3016L66.0849 39.0131L118.013 57.0391L131.544 52.1648L66.0849 26.9922L0 52.1648L17.1555 58.3016Z",
    fill: "#4C97FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M0 52.168V65.7698L66.0849 89.0103L131.544 64.7159V52.168L66.0849 75.8366L0 52.168Z",
    fill: "#4C97FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M0 25.1726L66.0849 0L131.544 25.1726L66.0849 48.8413L0 25.1726Z",
    fill: "#EB4526"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1555 31.3094L66.0849 12.021L118.013 30.0579L131.544 25.1726L66.0849 0L0 25.1726L17.1555 31.3094Z",
    fill: "#EB4526"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M0 25.1758V38.7776L66.0849 62.0291L131.544 37.7237V25.1758L66.0849 48.8444L0 25.1758Z",
    fill: "#EB4526"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXenonstackLogo);
export default __webpack_public_path__ + "static/media/xenonstack-logo.0a299e24f54d056198568d6e5e23a68d.svg";
export { ForwardRef as ReactComponent };